import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function AdminRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <main
        data-testid="admin-loading"
        className="min-h-screen bg-black text-white flex items-center justify-center"
      >
        <div className="font-mono text-xs uppercase tracking-[0.3em] text-acid">
          loading...
        </div>
      </main>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "admin") return <Navigate to="/home" replace />;
  return children;
}
